export enum ActionTypes {
  SetScopes = 'setScopes',
}
